import React, { useEffect } from 'react'
import { Autocomplete, Box, Button, ButtonGroup, IconButton, MenuItem, Select, SwipeableDrawer, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import CloseIcon from '@mui/icons-material/Close';
import "../trendStyles.scss";

export interface DrawerConfigProfileProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  profile: any
  onchangeProfileConfig: (variableId: string, key: string, value: any) => void
}

const typeOfChartOptions = [
  { id: "bar", name: "Barra" },
  { id: "line", name: "Linea" }
]

const sizeOfChartOptions = [
  { id: 1, name: "1" },
  { id: 2, name: "2" },
  { id: 3, name: "3" },
]

const setPointConfigList = [
  { id: "min", label: "Min" },
  { id: "average", label: "Average" },
  { id: "max", label: "Max" },
]

export const DrawerConfigProfile = ({ open, setOpen, profile, onchangeProfileConfig }: DrawerConfigProfileProps) => {


  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={() => setOpen(!open)}
      onOpen={() => setOpen(true)}
    >
      <Grid
        size={12}
        className="profile-config-drawer"
      >
        <Grid sx={{
          display: 'flex',
          justifyContent: 'space-between',
          borderBottom: '1px solid #ccc',
          alignItems: 'center',
          position: 'sticky',
          top: 0,
          backgroundColor: '#fff',
          zIndex: 1,
        }}>
          <Typography variant="body1" color="primary" sx={{ fontWeight: 'bold', fontSize: '15px', textAlign: 'center' }}>{profile?.name || ""}</Typography>
          <Grid>
            <IconButton
              size="small"
              color="primary"
              onClick={() => setOpen(!open)}
            >
              <CloseIcon />
            </IconButton>

          </Grid>

        </Grid>
        {profile?.config?.map((p: any, index: number) => {
          return (
            <Grid key={index} className="config-element-external" sx={{ width: '320px' }}>
              {/* variable Name */}
              <Grid className="config-element-line">
                <Typography>Variable</Typography>
                <Select
                  value={p.variableId}
                  size='small'
                  onChange={(e) => onchangeProfileConfig(p.variableId, "variable", e.target.value)}
                >
                  {profile?.variables?.map((v: any, index: number) => 
                  (<MenuItem key={index} value={v.variableId}>{v.name}</MenuItem>)
                  )}
                </Select>
              </Grid>
              {/* Line Type Name */}
              <Grid className="config-element-line">
                <Typography>Typo de Grafico</Typography>
                <Select
                  value={p.type}
                  size='small'
                  onChange={(e) => onchangeProfileConfig(p.variableId, "type", e.target.value)}
                >
                  {typeOfChartOptions?.map((v: any, index: number) => (<MenuItem key={index} value={v.id}>{v.name}</MenuItem>))}
                </Select>
              </Grid>
              {/* Line Size */}
              <Grid className="config-element-line">
                <Typography>Tamaño de grafico</Typography>
                <Select
                  value={p.size}
                  size='small'
                  onChange={(e) =>
                    onchangeProfileConfig(p.variableId, "size", e.target.value)
                  }
                >
                  {sizeOfChartOptions?.map((v: any, index: number) => (<MenuItem key={index} value={v.id}>{v.name}</MenuItem>))}
                </Select>
              </Grid>
              {/* line setpoints */}
              <Grid className="config-element-setpoints">
                {setPointConfigList?.map((sp: any, index: number) => {
                  return (
                    <Grid className="setpoint-element" key={index}>
                      <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                        <img src="/assets/icons/setpointDown.svg" alt="line" width={25} height={25} />
                        <Typography sx={{ width: '100%', textAlign: 'center', fontWeight: 'bold', fontSize: 12 }}>{sp.label}</Typography>
                      </Grid>
                      <Grid>
                        <TextField
                          size='small'
                          value={p[sp.id] || "Disabled"}
                          sx={{ backgroundColor: p[sp.id] ? '#fff' : '#ccc' }}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (!isNaN(Number(value))) {
                              onchangeProfileConfig(p.variableId, sp.id, Number(value))
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                  )
                })}
              </Grid>

            </Grid>
          )
        })}

      </Grid>

    </SwipeableDrawer>
  )
}
